import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import { getAssetUrl } from "../utils/assetUrl";
import "./ToolVideoBackground.css";

export default function ToolVideoBackground() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  const bgImage = getAssetUrl("/assets/llwin/bg-raw-2.png");

  return createPortal(
    <div
      className="tool-video-bg"
      style={{ backgroundImage: `url(${bgImage})` }}
      aria-hidden
    >
      <div className="tool-video-bg__overlay" />
      <div className="tool-video-bg__vignette" />
    </div>,
    document.body
  );
}
